 /* This file was generated by a tool. Modifying it will produce unexpected behavior. */
/* tslint:disable */

const strings = UNIT_TEST
                 ? require('resx-strings/en-us.json')
                 : require('resx-strings');
export interface IStrings {
  unableToResolveConfigError: string;
  invalidFrameworkModuleError: string;
}

export default (strings['_5v0SS2hk3k5Txrl8SXQ7pA'] || {}) as IStrings;



// WEBPACK FOOTER //
// /src/SystemJsWrapper.resx.ts